import React, { useState, useEffect } from 'react';
import SideBar from '../SideBare/index'
import Navbar from '../Navbar/index'
import { Menu } from 'lucide-react';


const MainLayout = ({ children }) => {
    const [isMobile, setIsMobile] = useState(false)
    const [isOpen, setIsOpen] = useState(true)

    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 868)
            if (window.innerWidth < 868) {
                setIsOpen(false)
            } else {
                setIsOpen(true)
            }
        }

        handleResize()
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])



    return (
        <div className="flex w-full h-screen overflow-y-auto bg-surface text-ink">
            <SideBar isOpen={isOpen} setIsOpen={setIsOpen} />
            <div className="flex-1 bg-surface overflow-x-hidden h-screen transition-all duration-300 flex flex-col">

                <Navbar isOpen={isOpen} setIsOpen={setIsOpen} isMobile={isMobile} />

                <main className={`w-full text-start mt-[4.5rem] bg-surface h-full transition-all duration-300 ${isOpen ? 'lg:pl-[264px]' : 'lg:pl-20'}`}>
                    {children}
                </main>
            </div>
        </div>
    );
};

export default MainLayout;
